// ═══ 말소 셸 더보기 동작 — 회사명 메뉴(parts/MalsoWhoMenu)·모바일 더보기·설정 전환 행이 공용 (B3 리뷰 C2) ═══
// 전환은 서버 플래그(대표 셀프)가 진실. 세션 갱신 순서 고정: 저장 → 이벤트(셸 재판정) → (전체 방향만) 이동.
// 이동을 먼저 하면 아직 말소 셸이라 catch-all 이 되돌리고, 그 뒤 user 가 바뀌어 빈 페이지가 뜬다.
// 로그아웃은 검차 셸과 같은 함수(simple/moreActions.js logoutSimple)를 쓴다.
import { putMalsoMode } from './api';
import { setMalsoPreview } from '../simple/screenMode';
import { describeSimpleError } from '../simple/errors';

/// 세션 user 의 malsoMode 를 숫자 1/0 으로 재저장 → 셸 재판정 → 전체 방향이면 대시보드로.
/// 서버 전환이 끝나면 이 기기의 '전체 기능 둘러보기'(simplify §7)도 끝낸다 — 어느 방향이든 둘러볼 이유가 없어진다.
export function applyMalsoMode(enabled, navigate) {
  var next = null;
  try {
    var raw = window.sessionStorage.getItem('autodoc_user');
    next = raw ? JSON.parse(raw) : null;
    if (next) {
      next.malsoMode = enabled ? 1 : 0;
      window.sessionStorage.setItem('autodoc_user', JSON.stringify(next));
    }
  } catch (e) { next = null; /* private mode / 파싱 실패 → 이벤트 생략 */ }
  if (next) {
    try { window.dispatchEvent(new CustomEvent('company-switched', { detail: next })); } catch (e) { /* 구형 브라우저 */ }
    setMalsoPreview(next, false);
  }
  if (!enabled && navigate) navigate('/main/dashboard');
}

function toastError(showToast, t, err) {
  if (!showToast) return;
  showToast(err && err.code === 'OWNER_ONLY' ? t('malsoModeSwitchOwnerOnly') : describeSimpleError(t, err), 'err');
}

/// 말소 → 전체. 403 OWNER_ONLY(대표 행 없는 legacy 계정 포함)는 세션을 건드리지 않고 토스트.
export function switchToFull(navigate, showToast, t) {
  return putMalsoMode(0).then(function () { applyMalsoMode(0, navigate); return true; })
    .catch(function (err) { toastError(showToast, t, err); return false; });
}

/// 전체 → 말소 (설정 화면 행). navigate 불필요 — 말소 셸 catch-all 이 현재 경로를 말소 홈으로 보낸다.
export function switchToMalso(navigate, showToast, t) {
  return putMalsoMode(1).then(function () { applyMalsoMode(1, navigate); return true; })
    .catch(function (err) { toastError(showToast, t, err); return false; });
}
